import { useQuery } from '@tanstack/react-query';
import { useTenantStore } from '../../../stores/tenant.store';
import { useStudentIdentity } from '../../../hooks/use-student-identity';
import { surveyApi } from '../../../lib/api/survey.api';
import { usePortalCacheScope } from '../../../stores/portal-view.store';

/** Open surveys the student may still answer (anonymous, in-window, unanswered). */
export function useOpenSurveys() {
  const { currentTenantId } = useTenantStore();
  const scope = usePortalCacheScope();
  const { personId } = useStudentIdentity();
  return useQuery({
    queryKey: ['portal-v2-open-surveys', currentTenantId, scope, personId],
    enabled: !!currentTenantId && !!personId,
    queryFn: async () => {
      const { surveys } = await surveyApi.listOpenForStudent({
        tenantId: currentTenantId!,
      });
      return surveys;
    },
    staleTime: 30_000,
  });
}
